var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuggestedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#007293"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4999 9.99983C16.5054 9.19659 16.2959 8.40651 15.893 7.7116C15.4901 7.0167 14.9085 6.44231 14.2087 6.04806C13.5088 5.65381 12.7162 5.45408 11.9131 5.46959C11.11 5.4851 10.3257 5.7153 9.64156 6.13629C8.95746 6.55727 8.39852 7.1537 8.02275 7.86364C7.64699 8.57359 7.4681 9.37117 7.50467 10.1736C7.54123 10.976 7.79191 11.754 8.23069 12.4269C8.66947 13.0997 9.28034 13.6428 9.99989 13.9998V15.4998C9.99989 15.6324 10.0526 15.7596 10.1463 15.8534C10.2401 15.9471 10.3673 15.9998 10.4999 15.9998H13.4999C13.6325 15.9998 13.7597 15.9471 13.8534 15.8534C13.9472 15.7596 13.9999 15.6324 13.9999 15.4998V13.9998C14.7474 13.6316 15.3773 13.0621 15.819 12.3555C16.2606 11.6489 16.4964 10.8331 16.4999 9.99983Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.5H14",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuggestedIcon);
export default __webpack_public_path__ + "static/media/suggested-icon.0670d1ad61ebba37fe3d227436923669.svg";
export { ForwardRef as ReactComponent };